<template>
  <div id="my-quotes-page" class="p-3">
    <main>
      <!-- Filters -->

      <!-- ## FILTERS ## -->
      <section
        class="header-container row align-center no-gutters"
        v-if="!loading"
      >
        <!-- Type of Projects -->
        <h1
          class="
            forza-bold
            text-uppercase
            col-xs-12 col-sm-12 col-md-12 col-lg-3
            mb-mobile-4
          "
        >
          Quote Requests
        </h1>
        <!-- By Title -->
        <div
          class="
            flex
            col-xs-12 col-sm-12 col-md-12 col-lg-8
            mb-mobile-4
            input-container
          "
          id="search-by-name-container"
        >
          <input
            type="text"
            class="form-control mr-3"
            placeholder="Search by customer or Catalog name and press enter"
            id="team-link-search"
            v-model="filters.search"
            @change="triggerSearch"
          />
          <button class="btn" @click="triggerSearch">
            <img src="@/assets/icons/ui/search-outline.svg" alt="" /> Search
          </button>
        </div>

        <!-- By Rep -->
        <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 mb-mobile-4">
              <div
                class="
                  flex
                  row
                  align-items-center
                  justify-content-around
                  no-gutters
                "
              >
                <label class="col-lg-4 text-lg-center" for="tl-"
                  >Filter by Rep</label
                >
                <select
                  class="form-control col-lg-8"
                  v-model="filters.rep_id"
                  @change="getQuotes(true)"
                >
                  <option value="0">All reps</option>
                  <option
                    v-for="rep in dealer.reps"
                    :key="rep.id + '-rep'"
                    :value="Number(rep.id)"
                  >
                    {{ rep.name }}
                  </option>
                </select>
              </div>
            </div> -->

        <!-- BY TYPE -->
        <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 mb-mobile-4">
              <div
                class="
                  flex
                  row
                  align-items-center
                  justify-content-around
                  no-gutters
                "
              >
                <label class="col-lg-4 text-lg-center" for="tl-"
                  >Filter by quote type</label
                >
                <select
                  class="form-control col-lg-8"
                  v-model="filters.filteredTypeOfProject"
                  @change="getQuotes(true)"
                >
                  <option disabled>Select a type</option>
                  <option
                    v-for="type in typesOfProjects"
                    :key="type + -'type'"
                    :value="type"
                  >
                    {{ type }}
                  </option>
                </select>
              </div>
            </div> -->
      </section>

      <!-- Quotes Table-->

      <MyQuotesTable
        v-if="!loading"
        :quotes="sortedQuotes"
        :filterByAllReps="filterByAllReps"
        :repsToFilter="repsToFilter"
        :showRepsFilter='true'
        :showRepsDropdownFilter="showRepsDropdownFilter"
        :showLink="true"
        @filterByRep="handleRepFilter"
        @filterByAllReps="repsToFilter = []"
        @toggleShowRepsFilter="showRepsDropdownFilter = !showRepsDropdownFilter"
      />

      <MyProjectsPagination
        v-if="!loading"
        :totalPages="totalPages"
        :selectedPage="page"
        :totalItems="totalItems"
        :sortedBy="sortedBy"
        :sortedByOptions="sortedByOptions"
        :showArchivedProjects="showArchivedProjects"
        v-on="{
          'on-set-page': setPage,
          'on-sort-by': setSortedBy,
          'on-toggle-checkbox': toggleShowArchiveProjects,
        }"
        :showCheckboxForArchiveProjects="true"
      />

      <!-- Loader -->
      <div class="loading-spinner" v-if="loading">
        <div class="flex flex-center">
          <div class="kt-spinner kt-spinner--md kt-spinner--info"></div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";

import MyQuotesTable from "@/components/Dashboard/Messages/MyQuotesTable.vue";
import MyProjectsPagination from "@/components/Dashboard/MyProjects/MyProjectsPagination.vue";

export default {
  name: "MyQuotes",
  components: {
    MyProjectsPagination,
    MyQuotesTable,
  },
  data() {
    return {
      customers: [],
      quotes: [],
      page: 1,
      totalPages: 1,
      totalItems: 1,
      editMode: false,
      loading: false,
      typesOfProjects: ["All", "Showrooms", "Playbooks", "Snapsheets"],
      typesOfProjectsToShow: "",
      filters: {
        search: "",
        rep_id: 0,
        filteredTypeOfProject: "All",
      },
      showArchivedProjects: true,
      showRepsDropdownFilter: false,
      repsToFilter: [],
      sortedBy: "newer",
      sortedByOptions: [
        { label: "Date Created (Newer)", value: "newer" },
        { label: "Date Created (Oldest)", value: "oldest" },
        { label: "Project Name (A to Z)", value: "a-to-z" },
        { label: "Project Name (Z to A)", value: "z-to-a" },
      ],
      //This will be the quote to pass to the modal
      projectToBeEdited: {},
      ToBeEdited: "",
      helpText:
        "All quotes you create will be saved here for you to access at any time. You can search based on the quote name, or filter by Rep and/or Project Type to keep track of where everything stands. If you want to hide any quotes from this page - please click on Quick Actions (•••) and Archive it.",
    };
  },
  computed: {
    ...mapState(["auth", "dealer", "settings"]),

    sortedQuotes() {
      switch (this.sortedBy) {
        case "newer":
          return [...this.filteredQuotes]?.sort(this.sortProjectsByDate);
        case "oldest":
          return [...this.filteredQuotes]
            .sort(this.sortProjectsByDate)
            .reverse();
        case "a-to-z":
          return [...this.filteredQuotes]?.sort(this.sortProjectsByTitle);
        case "z-to-a":
          return [...this.filteredQuotes]
            ?.sort(this.sortProjectsByTitle)
            ?.reverse();
        default:
          return [...this.filteredQuotes];
      }
    },

    filteredQuotes() {
      return this.showArchivedProjects
        ? [...this.quotes]
        : [...this.quotes].filter((pr) => {
            switch (pr.project_type) {
              case "showroom":
                return pr.status?.toLowerCase !== "archived";

              case "playbook":
                return (
                  pr.status_name?.toLowerCase() !== "archived" &&
                  pr.status?.toLowerCase() !== "archived"
                );

              case "snapsheet":
                return pr.status?.toLowerCase() !== "archived";

              default:
                //WTF 👀👀👀
                return true;
            }
          });
    },

    filterByAllReps: {
      get() {
        return this.repsToFilter.length === 0;
      },
      set() {
        if (this.repsToFilter.length) {
          this.repsToFilter = [];
        }
      },
    },
  },

  watch: {
    $route(to) {
      //React to the projects_type param in the url
      if (to.params.projects_type) {
        this.typesOfProjectsToShow = to.params.projects_type;
      } else {
        this.typesOfProjectsToShow = "";
      }
    },

    page() {
      this.getQuotes();
    },

    sortedBy() {
      this.getQuotes(true);
    },

    async filterByAllReps(value) {
      if (value)
        try {
          await this.getQuotes(true);
        } catch (error) {
          console.log(error);
        }
    },
  },

  methods: {
    ...mapActions(["setLoading"]),
    dateFormatted(created_at) {
      const currentDate = new Date(created_at);
      const day = currentDate.getDate();
      const month = currentDate.getMonth() + 1;
      const year = currentDate.getFullYear();
      return `${month}/${day}/${year}`;
    },

    setPage(page) {
      this.page = page;
    },

    setSortedBy(optSelected) {
      this.sortedBy = optSelected;
    },

    toggleShowArchiveProjects() {
      this.showArchivedProjects = !this.showArchivedProjects;
    },

    async triggerSearch() {
      await this.getQuotes(true); //todo improve
    },

    sortProjectsByDate(a, b) {
      return new Date(b.created_at) - new Date(a.created_at);
    },

    sortProjectsByTitle(a, b) {
      return a.title.localeCompare(b.title);
    },

    openEditModal({ quote, type }) {
      this.editMode = true;
      this.projectToBeEdited = quote;
      this.projectTypeToBeEdited = type;
    },

    editEvent() {
      this.editMode = false;
    },

    async handleRepFilter(rep) {
      //Find the rep in the array
      const index = this.repsToFilter.findIndex(
        (repId) => Number(repId) === Number(rep.id)
      );
      if (index === -1) {
        this.repsToFilter.push(rep.id);
      } else {
        this.repsToFilter = this.repsToFilter.filter(
          (id) => Number(id) !== Number(rep.id)
        );
      }
      try {
        await this.getQuotes(true);
      } catch (error) {
        console.log(error);
      }
    },

    async getQuotes(reset) {
      this.loading = true;
      if (reset) this.setPage(1);

      const params = {
        page: this.page,
        sort_by: this.sortedBy,
        per_page: 9,
      };

      //Reps Filter
      if (this.repsToFilter.length > 0) params["reps_ids"] = this.repsToFilter;

      if (this.filters.search.trim().length)
        params["search_query"] = this.filters.search.trim();

      await axios
        .get(this.$store.state.settings.endpoint + "api/v2/messages", {
          params,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.auth.apiToken,
          },
        })
        .then((response) => {
          this.quotes = response.data.data;
          this.totalPages = response.data.last_page;
          this.totalItems = response.data.total;
        })
        .catch((error) => {
          this.$store.dispatch("showToast", {
            txt: error,
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  async mounted() {
    this.typesOfProjectsToShow = this.$route.params.projects_type;
    this.$store.commit("setActivePage", `My ${this.typesOfProjectsToShow}s`);
    try {
      this.loading = true;
      await this.getQuotes();
    } catch (error) {
      this.loading = false;
      this.$store.dispatch("showToast", {
        txt: error,
        type: "error",
      });
    } finally {
      this.loading = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  margin-bottom: 1.75rem;
  h1 {
    font-size: 1.75rem;
    margin-right: 2rem;
  }

  .btn {
    border: 1px solid $grey-dark !important;
    color: $grey-dark !important;
    text-transform: capitalize;
    margin-left: auto;
    border-radius: 6px;
    padding: 0.5rem !important;
    &:hover {
      background-color: $grey-dark !important;
      color: white !important;
    }
    img {
      margin-right: 0.25rem;
    }
    a {
      color: $grey-dark !important;
      padding: 0.25rem;
    }
  }

  .input-container {
    input {
      border: 1px solid $placeholder !important;
      ::placeholder {
        color: $placeholder !important;
      }
      /* color: $placeholder !important; */
    }
  }
  #search-by-name-container {
    img {
      transition: all 0.2s;
    }
    &:hover {
      img {
        filter: invert(1);
      }
    }
  }
}

label {
  margin-bottom: 0;
}
select,
option {
  text-transform: capitalize;
}

.mb-mobile-4 {
  @media screen and (max-width: 1024px) {
    margin-bottom: 1.2rem;
  }
}
</style>